import { render, staticRenderFns } from "./FrenchWindowDamageSeverity.vue?vue&type=template&id=7706a137&scoped=true"
import script from "./FrenchWindowDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7706a137",
  null
  
)

export default component.exports